import React from 'react';
import PropTypes from 'prop-types';

import { MultiSelect } from '@metarouter-private/mr-mui';

import { useBulkDeployPageContext } from 'ion-experimental/app/bulk-deploy/BulkDeployPageContext';

export default function TagsMultiSelect({ disabled }) {
  const { selectedTagIds, setSelectedTagIds, tagOptions, tagsLoading } = useBulkDeployPageContext();

  const isDisabled = disabled || tagsLoading;

  return (
    <MultiSelect
      label="Tags"
      size="small"
      variant="outlined"
      value={selectedTagIds}
      options={tagOptions}
      onChange={setSelectedTagIds}
      disabled={isDisabled}
      data-test-id="filterTagsMultiSelect"
    />
  );
}

TagsMultiSelect.propTypes = {
  disabled: PropTypes.bool,
};
